import axios from 'axios'

export default {
    namespaced: true,
    actions: {
        FetchConstants({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/constants`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchConstants: ${error.message}`));
            });
        },
        FetchCAMSConstants({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/constants/cams`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCAMSConstants: ${error.message}`));
            });
        },
        FetchStudent({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/student`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudent: ${error.message}`));
            });
        },
        FetchStudentIndicators({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/indicators/studentid/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentIndicators: ${error.message}`));
            });
        },
        FetchStudentContactDetails({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/contactdetails/studentid/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentContactDetails: ${error.message}`));
            });
        },
        FetchStudentEmergencyContactDetails({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/emergencycontactdetails/studentid/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentEmergencyContactDetails: ${error.message}`));
            });
        },
        FetchStudentEnrolments({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/enrolments/upcoming/studentid/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentEnrolments: ${error.message}`));
            });
        },
        FetchStudentEnrolment({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/students/enrolments/enrolment/enrolmentid/${obj.EnrolmentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentEnrolment: ${error.message}`));
            });
        },
        FetchBursaryApplications({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/bursaries/upcoming/student/studentid/${obj.StudentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchBursaryApplications: ${error.message}`));
            });
        },
        FetchBursaryApplication({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/bursaries/enrolment/enrolmentid/${obj.EnrolmentID}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchBursaryApplication: ${error.message}`));
            });
        },
        FetchInductionEventsByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/inductionevents/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchInductionEventsByCourseCode: ${error.message}`));
            });
        },
        FetchInductionEventsByCourseCodes({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enterprisedata/data/fetch/inductionevents/coursecodes`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchInductionEventsByCourseCodes: ${error.message}`));
            });
        },
        FetchTimetableEventsByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/timetableevents/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchTimetableEventsByCourseCode: ${error.message}`));
            });
        },
        FetchTimetableEventsByCourseCodes({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/enterprisedata/data/fetch/timetableevents/coursecodes`, obj, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchTimetableEventsByCourseCodes: ${error.message}`));
            });
        },
        FetchFirstTimetableEventByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/timetableevents/coursecode/${obj.CourseCode}/first`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchFirstTimetableEventByCourseCode: ${error.message}`));
            });
        },
        FetchTitles({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/titles`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchTitles: ${error.message}`));
            });
        },
        FetchNationalities({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/nationalities`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchNationalities: ${error.message}`));
            });
        },
        FetchDomiciles({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/domiciles`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchDomiciles: ${error.message}`));
            });
        },
        FetchGroupSpecificValues({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/groupspecificvalues`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchGroupSpecificValues: ${error.message}`));
            });
        },
        FetchCountries({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/countries`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCountries: ${error.message}`));
            });
        },
        FetchRelationships({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/relationships`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchRelationships: ${error.message}`));
            });
        },
        FetchLanguages({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/languages`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchLanguages: ${error.message}`));
            });
        },
        FetchFinanceSources({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/financesources`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchFinanceSources: ${error.message}`));
            });
        },
        FetchEmploymentStatuses({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/employmentstatuses`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchEmloymentStatuses: ${error.message}`));
            });
        },
        FetchStudentCategories({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/studentcategories`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStudentCategories: ${error.message}`));
            });
        },
        FetchQualificationLevels({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/qualificationlevels`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchQualificationLevels: ${error.message}`));
            });
        },
        FetchSchools({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/schools`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchSchools: ${error.message}`));
            });
        },
        FetchCaringResponsibilities({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/caringresponsibilities`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCaringResponsibilities: ${error.message}`));
            });
        },
        FetchCareSettings({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/caresettings`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCareSettings: ${error.message}`));
            });
        },
        FetchGenders({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/genders`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchGenders: ${error.message}`));
            });
        },
        FetchGenderIdentities({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/genderidentities`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchGenderIdentities: ${error.message}`));
            });
        },
        FetchGenderExpressions({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/genderexpressions`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchGenderExpressions: ${error.message}`));
            });
        },
        FetchEthnicities({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/ethnicities`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchEthnicities: ${error.message}`));
            });
        },
        FetchReligions({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/religions`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchReligions: ${error.message}`));
            });
        },
        FetchSexualOrientations({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/sexualorientations`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchSexualOrientations: ${error.message}`));
            });
        },
        FetchMaritalStatuses({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/maritalstatuses`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchMaritalStatuses: ${error.message}`));
            });
        },
        FetchPregnancyOptions({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/pregnancyoptions`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchPregnancyOptions: ${error.message}`));
            });
        },
        FetchServiceStudents({ }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/lookups/servicestudents`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchServiceStudents: ${error.message}`));
            });
        },
        FetchCoursePeriodByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/courseperiods/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCoursePeriodByCourseCode: ${error.message}`));
            });
        },
        FetchCourseMarketingByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/coursemarketing/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchCourseMarketingByCourseCode: ${error.message}`));
            });
        },
        FetchUnitsByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/units/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchUnitsByCoursePeriodCode: ${error.message}`));
            });
        },
        FetchOptionGroupsByCourseCode({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/units/optiongroups/coursecode/${obj.CourseCode}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchOptionGroupsByCoursePeriodCode: ${error.message}`));
            });
        },
        FetchStaffByUsername({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/enterprisedata/data/fetch/staff/username/${obj.Username}`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.status === 200) resolve(JSON.parse(response.data.payload));
                        else reject(response);
                    }).catch(error => reject(`FetchStaffByUsername: ${error.message}`));
            });
        },
    },
}
